import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { goodsinfoAdverList } from 'lib/api/goods';
import { showSuccessSnackbar } from 'modules/snackbar';

import AutoComplete from 'components/molecules/NewSelectBox/AutoComplete';

const AdverIdList = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { params, getParam, name = 'adverId', disabled } = props;
  const [adverList, setAdverList] = useState([]);

  useEffect(() => {
    goodsinfoAdverList()
      .then((response) => {
        const { data } = response.data;
        setAdverList(data);
      })
      .catch((error) => {
        handleClickSnackbar({
          message: error,
          option: {
            type: 'error',
          },
        });
      });
    // eslint-disable-next-line
  }, []);

  /**
   * 스낵바 리덕스 값을 변경해주는 함수
   * @type {(...args: any[]) => any}
   */
  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  return (
    <AutoComplete
      list={adverList}
      label={t('광고주ID')}
      name={name}
      valueKey="USER_ID"
      labelKey="USER_ID"
      getParam={getParam}
      params={params}
      type="filter"
      disabled={disabled}
    />
  );
};

export default AdverIdList;
